<template lang="pug">
v-img(
  v-bind="extendAttrs"
  @loadstart="setLoading(true)"
  @load="setLoading(false)"
)
  .d-flex.justify-center.align-center.full-height(
    :class="{ 'opacity-60': loading }"
    v-if="showIcon"
  )
    v-icon(v-bind="extendIconAttrs") {{ icon }}
  slot
</template>

<script>
const DEFAULT_SIZE = 40;

export default {
  name: 'AppAvatar',
  props: {
    avatar: {
      type: [Object, String],
      default: null,
    },
    size: {
      type: [Number, String, null],
      default: DEFAULT_SIZE,
    },
    noAvatar: {
      type: String,
      default: require('@/assets/no-avatar.png'),
    },
    icon: {
      type: String,
      default: '',
    },
    iconAttrs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    avatarImage() {
      const { avatar } = this;
      return avatar?.thumb || avatar?.url || null;
    },
    src() {
      const { noAvatar, avatarImage } = this;
      return avatarImage || noAvatar;
    },
    showIcon() {
      const { icon, loading, avatarImage } = this;
      return icon && (loading || !avatarImage);
    },
    srcSet() {
      const {
        src,
        noAvatar,
        avatarImage,
        showIcon,
      } = this;
      const onlyIcon = showIcon && !avatarImage;
      return {
        src: onlyIcon ? null : src,
        'lazy-src': showIcon ? null : noAvatar,
      };
    },
    extendAttrs() {
      const {
        srcSet,
        size,
        $attrs,
      } = this;
      const currentSize = Number(size);

      return {
        ...srcSet,
        alt: 'Аватар пользователя',
        ...currentSize ? {
          'max-width': currentSize,
          'min-width': currentSize,
          'max-height': currentSize,
          'min-height': currentSize,
        } : {},
        ...$attrs,
      };
    },
    extendIconAttrs() {
      const { iconAttrs } = this;
      return {
        size: 24,
        color: 'redesignBlack',
        ...(iconAttrs || {}),
      };
    },
  },
  methods: {
    setLoading(state) {
      this.loading = state;
    },
  },
};
</script>
